import React from 'react';
import PropTypes from 'prop-types';
import { ButtonWithIcon } from '@els/els-react--button';
import { byValue, occurrence } from '@Containers/ResultsFilters/ResultsFiltersConstants';
import Pagination from '@Containers/ResultsFilters/ResultsFiltersComponents/BarChartCheckboxesDialog/BarChartCheckboxesDialogFooter/Pagination';

function DialogFooter({
  id,
  chunksCount,
  activeChunkIndexAsInteger,
  setActiveChunkId,
  onClickLimitTo,
  onClickExclude,
  disableLimitTo,
  disableExclude,
  sortingType,
  customGroups,
  onClickGoToButton,
}) {
  return chunksCount ? (
    <footer className="bar-chart-checkboxes-dialog__footer">
      {(!customGroups || sortingType !== byValue) && (
        <Pagination
          id={id}
          chunksCount={chunksCount}
          setActiveChunkId={setActiveChunkId}
          activeChunkIndexAsInteger={activeChunkIndexAsInteger}
          onClickGoToButton={onClickGoToButton}
        />
      )}
      <div className="bar-chart-checkboxes-dialog__buttons">
        <ButtonWithIcon
          sprite="ChevronRight"
          type="secondary"
          iconRight
          disabled={disableExclude}
          onClick={onClickExclude}
          className="e2e-exclude">
          Exclude
        </ButtonWithIcon>
        <ButtonWithIcon sprite="ChevronRight" iconRight disabled={disableLimitTo} onClick={onClickLimitTo} className="e2e-limit-to">
          Limit to
        </ButtonWithIcon>
      </div>
    </footer>
  ) : null;
}

DialogFooter.propTypes = {
  id: PropTypes.string.isRequired,
  chunksCount: PropTypes.number,
  onClickLimitTo: PropTypes.func.isRequired,
  onClickExclude: PropTypes.func.isRequired,
  disableLimitTo: PropTypes.bool,
  disableExclude: PropTypes.bool,
  setActiveChunkId: PropTypes.func.isRequired,
  onClickGoToButton: PropTypes.func.isRequired,
  activeChunkIndexAsInteger: PropTypes.number.isRequired,
  sortingType: PropTypes.oneOf([occurrence, byValue]).isRequired,
  customGroups: PropTypes.bool,
};

export default DialogFooter;
